import { cn } from "@/lib/utils"

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'brand';
}

function Skeleton({
  className,
  variant = 'default',
  ...props
}: SkeletonProps) {
  return (
    <div
      className={cn(
        "rounded-md",
        variant === 'brand' ? 'skeleton-brand' : 'animate-pulse bg-muted',
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
